import React from "react";
import { motion } from "framer-motion";
import { industries } from "../Data";

const Industries = ({heading}) => {
  return (
    <>
      <section className="industries-section">

        <div className="container">

          {/* HEADING */}
          <motion.h3
            className="section-subheading"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            INDUSTRIES WE SERVE
          </motion.h3>

          <motion.h2
            className="section-heading"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.15,
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
            }}
            viewport={{ once: true }}
          >
            { heading || "Precision Packaging for Every Industrial Application." }
          </motion.h2>

          {/* GRID */}
          <motion.div
            className="industries-grid"
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.12,
                },
              },
            }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
          >

            {industries.map((item, i) => (
              <motion.div
                className="industries-card"
                key={i}
                variants={{
                  hidden: {
                    opacity: 0,
                    y: 50,
                  },
                  visible: {
                    opacity: 1,
                    y: 0,
                  },
                }}
                transition={{
                  duration: 0.7,
                  ease: [0.22, 1, 0.36, 1],
                }}
                whileHover={{
                  y: -8,
                  scale: 1.03,
                }}
              >

                {/* ICON */}
                <motion.img
                  src={item.icon}
                  alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
                  whileHover={{
                    scale: 1.12,
                    rotate: 3,
                  }}
                  transition={{ duration: 0.3 }}
                />

                {/* TITLE */}
                <motion.h4
                  className="card-heading"
                  whileHover={{
                    letterSpacing: "0.4px",
                  }}
                >
                  {item.title}
                </motion.h4>

              </motion.div>
            ))}

          </motion.div>

        </div>

      </section>
    </>
  );
};

export default Industries;